module.exports = __webpack_public_path__ + "img/donationCard.313fbcb4.svg";